// extracted by mini-css-extract-plugin
module.exports = {"contact-nums":"style_contact-nums__ZB9VS"};